import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Label,
    Icon, Form, Dropdown, Table, Popup, Card, Placeholder, Divider, Tab, Loader
} from 'semantic-ui-react';
import download from 'downloadjs';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link } from 'react-router-dom';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import moment from 'moment';
import ReactApexChart from 'react-apexcharts';
import { center } from '../../Statistics/util';
import finalPropsSelectorFactory from 'react-redux/lib/connect/selectorFactory';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import SimpleStatisticTable from './SimpleStatisticTable';
import SimpleOptionsAnswersWithCommentTable from './SimpleOptionsAnswersWithCommentTable';


export default class StaffResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showNoCommentMess: false,
            QuestionList: [{
                questionText: 'pitane?',
                answers: [1, 2, 3, 5],
                averagePerQuestion: 2.6,
                questionOptions: ['opt1', 'opt2', 'opt3', 'opt4'],
                questionComments: ['comment1', 'comment2']
            }, {
                questionText: 'pitane?',
                answers: [1, 2, 3, 5],
                averagePerQuestion: 2.6,
                questionOptions: ['opt1', 'opt2', 'opt3', 'opt4'],
                questionComments: ['comment1', 'comment2', 'comment2', 'comment2', 'comment2', 'comment2']
            }],
            options2: {
                colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3'],
                fill: {
                    colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3']
                },

                labels: ['Ocjena 1', 'Ocjena 2', 'Ocjena 3', 'Ocjena 4', 'Ocjena 5'],

                title: {
                    text: 'Statistika'
                },

                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            series2: [8, 5, 7, 5, 9],
            options3: {},
            series3: [],
            matrix: [[1, 2, 3], [2, 3, 5], []]


        };

        this.prepareDataForPollChart = this.prepareDataForPollChart.bind(this);
        // this.prepareDataForQuestionChart = this.prepareDataForQuestionChart.bind(this);
        this.getDataForQuestion = this.getDataForQuestion.bind(this);
        this.printReport = this.printReport.bind(this);
    }


    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps);
        console.log(nextContext);
        let { sectionId } = nextProps;
        let obj = {
            courseImplementationGroup: null,
            courseImplementation: localStorage.getItem('courseId') ? { id: localStorage.getItem('courseId') } : null,
            studyProgram: localStorage.getItem('studyProgramId') ? { id: localStorage.getItem('studyProgramId') } : null,
            organizationalUnitEmployee: null
        };
        axios.post(`/questionnaire/statistics/${JSON.parse(localStorage.getItem('poll')).pollId}/${sectionId}/`, { ...obj })
            .then(res => {
                let courseData = res.data;
                let QuestionList = res.data;


                this.setState({
                    QuestionList, loading: false
                }
                    // , () => this.prepareDataForQuestionChart()
                );
            }).catch(err => {
                console.log('Failed to fetch poll data for staff.');
            });
    }

    componentWillMount() {
        let { sectionId } = this.props;
        this.prepareDataForPollChart();
        let obj = {
            courseImplementationGroup: null,
            courseImplementation: localStorage.getItem('courseId') ? { id: localStorage.getItem('courseId') } : null,
            studyProgram: localStorage.getItem('studyProgramId') ? { id: localStorage.getItem('studyProgramId') } : null,
            organizationalUnitEmployee: null
        };
        axios.post(`/questionnaire/statistics/${JSON.parse(localStorage.getItem('poll')).pollId}/${sectionId}/`, { ...obj })
            .then(res => {
                let courseData = res.data;
                let QuestionList = res.data;


                this.setState({
                    QuestionList, loading: false
                }
                // , () => this.prepareDataForQuestionChart()
                );
            }).catch(err => {
                console.log('Failed to fetch poll data for staff.');
            });
    }

    printReport() {
        let obj = {
            language: 'bs',
            questionnaireId: JSON.parse(localStorage.getItem('poll')).pollId,
            courseImplementationId: parseInt(localStorage.getItem('courseId'), 10),
            course: 0
        };
        axios({
            method: 'post',
            url: '/documents/employee-questionnaire-statistics-report/',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Štampanje nije izvršeno.');
            });
    }
    getDataForQuestion(i) {
        return this.state.matrix[i] ? this.state.matrix[i] : [];
    }
    // prepareDataForQuestionChart() {
    //     let data = this.state.QuestionList;
    //
    //     let allPollData = data[0].questionDTOS;
    //
    //     let matrix = allPollData.map((e, i) => {
    //         let tempList = e.answerDTOS.map((el) => (el.numberOfAnswers));
    //         return tempList;
    //     });
    //
    //     this.setState({ matrix });
    // }
    prepareDataForPollChart() {
        axios.get(`/questionnaire/statistics/chart/${JSON.parse(localStorage.getItem('poll')).pollId}/${localStorage.getItem('courseId')}/0/`)
            .then(res => {
                let courseChartData = res.data;


                let options3 = {
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: courseChartData.questions.map((e, i) => ('Pitanje ' + (i + 1)))
                    },
                    yaxis: {
                        title: {
                            text: 'broj studenata'
                        }
                    },
                    fill: {
                        opacity: 1,
                        colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3', '#4fc2f8']
                    },
                    tooltip: {
                        y: {
                            formatter(val) {
                                return val;
                            }
                        }
                    },
                    colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3', '#4fc2f8']
                };

                let series3 = courseChartData.answers.map((e) => (e.name === 'cannot rate' ? {
                    name: 'Ne mogu procijeniti',
                    data: e.data
                } : e));


                this.setState({ options3, series3 });
            }).catch(err => {
                console.log('Failed to fetch poll data for staff.');
            });
        // this.setState({ series2: 0 });
    }


    render() {
        let activeRole = localStorage.getItem('activeRole');
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (!this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            // dodati loader

            <div>


                <SimpleStatisticTable
                    questionList={this.state.QuestionList}
                    tableRibbonLabel="Broj studenata koji su odg pitanja"
                    buttonReport
                    tableHeader
                    buttonReportText="Izvještaj"
                    graphically
                    questionOptions={['Ocjena 1', 'Ocjena 2', 'Ocjena 3', 'Ocjena 4']}
                    averageForQuestionnaire={4.2}

                />
                <br />
                <SimpleOptionsAnswersWithCommentTable
                    questionList={this.state.QuestionList}
                    tableRibbonLabel="Broj studenata koji su odg pitanja"
                    buttonReport
                    buttonReportText="Izvještaj"
                    graphically
                />

                {/* {this.state.QuestionList.length ? <Table celled selectable compact> */}
                {/*    <Table.Header> */}
                {/*        <Table.Row > */}
                {/*            <Table.HeaderCell colSpan={12}> */}
                {/*                <Label ribbon color="blue">{ activeRole.substr(0, 8) === 'Profesor' ? 'Broj studenata koji su ocijenili profesora: ' : activeRole.substr(0, 8) === 'Asistent' ? 'Broj studenata koji su ocijenili asistenta: ' : ''}  {localStorage.getItem('numberOfStudentsWhoRatedEmployee')}</Label> */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell colSpan={2} textAlign="center"> */}
                {/*                <Header style={IconHeader} textAlign="center"> */}
                {/*                    <Button */}
                {/*                        icon="download" */}
                {/*                        content="Izvještaj" */}
                {/*                        // labelPosition="right" */}
                {/*                        color="blue" */}
                {/*                        size="small" */}
                {/*                        style={FiltersOnStyle} */}
                {/*                        onClick={this.printReport} */}
                {/*                    > */}
                {/*                    </Button> */}

                {/*                </Header> */}

                {/*            </Table.HeaderCell> */}
                {/*        </Table.Row> */}
                {/*        <Table.Row> */}

                {/*            <Table.HeaderCell > */}

                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell colSpan={5}> */}
                {/*                Sadržaj pitanja */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center"> */}
                {/*                Grafički prikaz */}
                {/*            </Table.HeaderCell> */}
                {/*          */}
                {/*            <Table.HeaderCell textAlign="center" > */}
                {/*                Ocjena 1 */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center" > */}
                {/*                Ocjena 2 */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center"> */}
                {/*                Ocjena 3 */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center"> */}
                {/*                Ocjena 4 */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center"> */}
                {/*                Ocjena 5 */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center"> */}
                {/*                Ne mogu procijeniti */}
                {/*            </Table.HeaderCell> */}
                {/*            <Table.HeaderCell textAlign="center"> */}
                {/*                Prosjek */}
                {/*            </Table.HeaderCell> */}

                {/*           */}


                {/*        </Table.Row> */}
                {/*    </Table.Header> */}
                {/*    <Table.Body> */}
                {/*        {this.state.QuestionList[0].questionDTOS.map((el, index) => */}
                {/*            (el.questionType !== 'text' ? <Table.Row key={index}> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center"> */}
                {/*                    {index + 1}. */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell colSpan={5} verticalAlign="middle" > */}
                {/*                    {el.questionText} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" width={1}> */}
                {/*                    /!* <Icon bordered color="blue" name="chart bar" /> *!/ */}
                {/*                    <Dropdown */}
                {/*                        simple */}
                {/*                        className="icon" */}
                {/*                        icon="chart pie" */}
                {/*                        bordered */}
                {/*                        color="blue" */}
                {/*                    > */}

                {/*                        <Dropdown.Menu> */}

                {/*                            <Dropdown.Item><Card fluid> */}
                {/*                                <Card.Content> */}

                {/*                                    <div id="chart"> */}
                {/*                                        <ReactApexChart options={this.state.options2} series={this.getDataForQuestion(index)} type="pie" width="400" height="400" /> */}
                {/*                                    </div> */}
                {/*                                </Card.Content> */}
                {/*                            </Card></Dropdown.Item> */}

                {/*                        </Dropdown.Menu> */}
                {/*                    </Dropdown> */}
                {/*                </Table.Cell> */}
                {/*              */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center"> */}
                {/*                    {el.answerDTOS.find((e) => e.questionName === '1.0').numberOfAnswers} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" > */}
                {/*                    {el.answerDTOS.find((e) => e.questionName === '2.0').numberOfAnswers} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" > */}
                {/*                    {el.answerDTOS.find((e) => e.questionName === '3.0').numberOfAnswers} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" > */}
                {/*                    {el.answerDTOS.find((e) => e.questionName === '4.0').numberOfAnswers} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" > */}
                {/*                    {el.answerDTOS.find((e) => e.questionName === '5.0').numberOfAnswers} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" > */}
                {/*                    {el.cannotRate} */}
                {/*                </Table.Cell> */}
                {/*                <Table.Cell verticalAlign="middle" textAlign="center" warning={parseFloat(el.averagePerQuestion).toFixed(2) >= 2 && parseFloat(el.averagePerQuestion).toFixed(2) <= 4} negative={parseFloat(el.averagePerQuestion).toFixed(2) < 2} positive={parseFloat(el.averagePerQuestion).toFixed(2) > 4}> */}
                {/*                    {el.averagePerQuestion ? parseFloat(el.averagePerQuestion).toFixed(2) : 0} */}
                {/*                </Table.Cell> */}
                {/*            </Table.Row> : false))} */}
                {/*       */}
                {/*    </Table.Body> */}
                {/*    <Table.Footer> */}
                {/*        <Table.Row> */}

                {/*            <Table.HeaderCell colSpan={13} verticalAlign="middle" textAlign="right"><h4>UKUPAN PROSJEK:</h4></Table.HeaderCell> */}
                {/*            <Table.HeaderCell */}
                {/*                verticalAlign="middle" */}
                {/*                textAlign="center" */}
                {/*                warning={parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2) >= 2 && parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2) <= 4} */}
                {/*                positive={parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2) > 4} */}
                {/*                negative={parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2) < 2} */}
                {/*            ><h4>{parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2) < 2 && <Icon color="red" name="attention" />} */}
                {/*                {parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2) > 4 && <Icon color="green" name="checkmark" />} */}
                {/*                {parseFloat(this.state.QuestionList[0].averageForQuestionnaire).toFixed(2)}</h4></Table.HeaderCell> */}
                {/*        </Table.Row> */}
                {/*       */}
                {/*    </Table.Footer> */}
                {/* </Table> : 'Ankete nije sadržavala pitanja o profesoru.'} */}
                {/* <br /> */}
                {/* <Segment> */}
                {/*    <div id="chart"> */}
                {/*        <ReactApexChart options={this.state.options3} series={this.state.series3} type="bar" height="350" /> */}
                {/*    </div> */}
                {/* </Segment> */}


                <br />
                <Divider horizontal>
                    <Header as="h4">

                        Pohvale/Primjedbe/Sugestije
                    </Header>

                </Divider>


                {/* {this.state.QuestionList.length ? */}

                {/*    this.state.QuestionList[0].questionDTOS.map((el, index) => { */}
                {/*        let i = 1; */}

                {/*        return el.questionType === 'text' ? */}

                {/*            el.answerDTOS.length ? */}
                {/*                <Table selectable celled compact> */}
                {/*                    { el.answerDTOS[0].textAnswers.map((e, index) => ( */}
                {/*                        <Table.Body> */}
                {/*                            <Table.Row> */}
                {/*                                <Table.Cell verticalAlign="middle" textAlign="center"> */}
                {/*                                    {i++}. */}
                {/*                                </Table.Cell> */}
                {/*                                <Table.Cell width={15} verticalAlign="middle" textAlign="left"> */}
                {/*                                    {e} */}
                {/*                                </Table.Cell> */}

                {/*                            </Table.Row> */}
                {/*                        </Table.Body> */}

                {/*                    )) } </Table> : <p float="center">Trenutno nema zabilježenih odgovora.</p> */}
                {/*            : false; */}
                {/*    }) : false */}


                {/* } */}


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/StaffResults.js